export default "__VITE_ASSET__KfdEAg_H__"